module.exports = require("@gauzy/plugin-integration-zapier");